import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import config from '../config';

const appInsights = new ApplicationInsights({
  config: {
    instrumentationKey: config.applicationInsightsKey
  }
});

appInsights.loadAppInsights();
appInsights.trackPageView();

export default appInsights;


// WEBPACK FOOTER //
// ./src/helpers/appInsights.js